import { useI18n } from "@/i18n/LanguageContext";
import { Reveal } from "@/components/site/Reveal";

export const EventSnapshot = () => {
  const { t } = useI18n();
  return (
    <section className="border-b border-border bg-card">
      <div className="container-site section-pad py-10 md:py-12">
        <div className="grid grid-cols-2 gap-x-6 gap-y-8 md:grid-cols-3 lg:grid-cols-5">
          {t.snapshot.map((item, i) => (
            <Reveal key={i} delay={i * 0.06} className={`flex flex-col ${i !== 0 ? "lg:border-l lg:border-border lg:pl-6" : ""}`}>
              <span className="font-display text-lg font-medium leading-tight text-primary sm:text-xl">{item.value}</span>
              <span className="mt-1 text-xs font-medium uppercase tracking-[0.14em] text-muted-foreground">{item.label}</span>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
